mutation SubscribeGoogleMeetWebhooks($input: GoogleMeetWebhooksSubscribeInput!) {
    googleMeetWebhooksSubscribe(input: $input) {
        googleMeetIntegration {
            isEnabledCalendarSync
            isEnabledMeetSync
            email
        }
    }
}
